module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9jxrb"))).then(() => module.bundle.root('d0iPb'));